<template>
  <div>
    <div v-if="way == '2'">
      <a-button
        style="color: #98baff"
        type="link"
        icon="question-circle"
        @click="() => (modal2Visible = true)"
        block
      >
        单轮竞价说明
      </a-button>
      <a-modal
        v-model="modal2Visible"
        title="单轮竞价说明"
        :footer="null"
        centered
        @ok="() => (modal2Visible = false)"
      >
        <p>
          报名供应商在竞价时限内，只能进行
          <span class="color-red">一次报价</span>
          操作，系统以该报价作为供应商的最终报价。
        </p>
        <p>
          在竞价时限内，各个供应商的报价
          <span class="color-red">互不可见 </span>
          ，招标代理机构的经办人对所有供应商的报价
          <span class="color-red"> 也不可见 </span>。
        </p>
        <p>
          竞价时限到期后竞价结束，系统<span class="color-red">自动公布</span
          >所有供应商的报价，并按照“满足竞价项目要求且有效报价最高（或最低）”的原则自动确定拟成
        </p>
        <p>
          交供应商。<span class="color-red"
            >如存在多条相同的最高（或最低）报价，则以先报价的供应商为拟成交供应商。</span
          >
        </p>

        <div>
          <b class="bold size3 color-black">单轮竞价方式</b>
          <p>
            单轮竞价包括 <span class="color-red">竞低价</span> 和 
            <span class="color-red"> 竟高价 </span>
             两种方式，竞低价为最低价成交；竞高价为最高价成交。
          </p>
        </div>
        <div>
          <b class="bold size3 color-black">报价限制</b>
          <p class="mb-0">供应商报价必须不高于最高限价（或不低于最低限价）。</p>
        </div>
        <div>
          <b class="bold size3 color-black">项目失败条件</b>
          <p class="mb-0">
            条件一：<span class="color-red">报名供应商数量</span
            >少于竞价文件所规定的家数。
          </p>
          <p class="mb-0">
            条件二：<span class="color-red">报价供应商数量</span
            >少于竞价文件所规定的家数。
          </p>
          <p>
            一般情况下，系统自动根据以上两类失败条件来自动判定项目是否竞价失败。
            如竞价过程中发生异常情况（如发现供应商有串标行为），可以由采购人来决定项目是否失败。
          </p>
        </div>
      </a-modal>
    </div>
    <div v-else-if="way == '1'">
      <a-button
        style="color: #98baff"
        type="link"
        icon="question-circle"
        @click="() => (modal2Visible = true)"
        block
      >
        自由竞价说明
      </a-button>
      <a-modal
        v-model="modal2Visible"
        title="自由竞价说明"
        :footer="null"
        centered
        @ok="() => (modal2Visible = false)"
      >
        <p>
          报名供应商在竞价时限内，可以多次进行报价操作，系统以每个供应商最后一次成功报价作为该供应商的最终报价。竞价结束后，系统按照“满足竞价项目要求且有效报价最低（或最高）”的原则自动确定成交供应商。
        </p>
        <div>
          <b class="bold size3 color-black">自由竞价方式</b>
          <p>
            自由竞价包括
            <span class="color-red">竞低价</span>
            和
            <span class="color-red">竟高价</span>
            两种方式，竞低价为最低价成交；竞高价为最高价成交。
          </p>
        </div>
        <div>
          <b class="bold size3 color-black">竞价时限</b>
          <p class="mb-0">
            每个竞价项目的竞价过程由
            <span class="color-red">常规竞价阶段</span>
            和
            <span class="color-red">倒计时阶段</span>
            组成。
          </p>
          <p class="mb-0">
            <span class="color-red">竞价时长</span>
            ：指项目的常规竞价阶段时长，此阶段的时长是固定的，计时不受供应商报价与否的影响。
          </p>
          <p>
            <span class="color-red">倒计时时长</span>
            ：常规竞价时间截止后，项目自动进入倒计时竞价阶段，此阶段内凡有供应商报价，则倒计时时间自动重新开始，直到无供应商再次报价，倒计时归零为止，此时项目竞价结束。
          </p>
        </div>
        <div>
          <b class="bold size3 color-black">报价限制</b>
          <p class="mb-0">供应商报价必须不高于最高限价（或不低于最低限价）。</p>
          <p>供应商每次报价必须满足加（减）价幅度的要求。</p>
        </div>
        <div>
          <b class="bold size3 color-black">项目失败条件</b>
          <p class="mb-0">
            条件一：<span class="color-red">报名供应商数量</span
            >少于竞价文件所规定的家数。
          </p>
          <p class="mb-0">
            条件二：<span class="color-red">报价供应商数量</span
            >少于竞价文件所规定的家数。
          </p>
          <p>
            一般情况下，系统自动根据以上两类失败条件来自动判定项目是否竞价失败。
            如竞价过程中发生异常情况（如发现供应商有串标行为），可以由采购人来决定项目是否失败。
          </p>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: ['way'],
  data() {
    return {
      modal2Visible: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
